import React from 'react'
import style2 from './model.module.scss'
import Icon from 'components/Icon/Icon'
import ReactDOM from 'react-dom'
import ModelLoading from './ModelLoading'

interface IProps {
  children: any,
  show: boolean,
  onHide: () => any,
  style?: object,
  loading?: boolean
}

function Model ({ children, show = false, onHide, style, loading }: IProps) {
  if (!show) {
    return null
  }

  return ReactDOM.createPortal(
    <div className={style2.model}>
      <div
        onClick={onHide}
        className={style2.cover}></div>
      <div
        style={style}
        className={style2.content}
      >
        { loading && <ModelLoading /> }
        <Icon
          onClick={onHide} 
          className={style2.close} icon="iconicon_exit" />
        <div className="body">
          {children}
        </div>
      </div>
    </div>,
    document.getElementById('modal-root') as Element
  )
}

export default Model
